export default __webpack_public_path__ + "static/media/zoha.3b9b6b45.png";